import React, { FC } from 'react';

import MarkerBase from '../views/marker-base';
import { Root, Base } from './index.styled';

const AbstractMapMarker: FC = ({ children }) => {
  return (
    <Root>
      <Base><MarkerBase /></Base>
      {children}
    </Root>
  );
};

export default AbstractMapMarker;
